import { RootState, useAppSelector } from "../redux/AppStore";
export default function FooterComponent() {
  const message = useAppSelector((state: RootState) => state.tracking.companyinfo);
    return (
        <div className="message_sec">
          {message!= null &&
        <p><strong>Message:</strong>{message.instruction_messge}</p>
          }
      </div>
    );
  }